// Define the handler class
function SearchResultFilters(rootEl) {
	// Define classes
	const selectClass = 'search-results-filters__select';
	const filtersContainerClass = 'search-results-filters';
	this.filterClass = 'search-results-filters__filter';
	this.activeFilterClass = 'search-results-filters__filter--active';
	const resultClass = 'search-results-grid__result';
	this.resultHiddenClass = 'hidden';

	// Get filters container
	this.filtersContainerEl = document.querySelector('.' + filtersContainerClass);
	if (!(this.filtersContainerEl instanceof window.HTMLElement)) {
		return;
	}

	// Get filter els
	this.allFilterEls = Array.from(this.filtersContainerEl.querySelectorAll('.' + this.filterClass));

	// Get result els
	this.allResultEls = Array.from(document.querySelectorAll('.' + resultClass));

	// Get the select el
	this.selectEl = this.filtersContainerEl.querySelector('.' + selectClass);

	// Fail if elements are missing
	if (
		0 === this.allFilterEls.length ||
		0 === this.allResultEls.length ||
		!(this.selectEl instanceof window.HTMLElement)
	) {
		return;
	}

	// Changing the select will change the active filter
	this.selectEl.addEventListener('change', this.handleSelectChange.bind(this));

	// Clicking a filter will change the active filter
	this.filtersContainerEl.addEventListener('click', this.handleFilterClick.bind(this));
}

/**
 * Changing the select will change the active filter
 * @param     { Event } event    An event raised by the user action
 * @return    void
 */
SearchResultFilters.prototype.handleSelectChange = function(event) {
	// Update the page
	const selectedType = String(this.selectEl.value);
	this.updateActiveFilter(selectedType);
};

/**
 * Clicking a filter will change the active filter
 * @param     { MouseEvent } event    An event raised by the user action
 * @return    void
 */
SearchResultFilters.prototype.handleFilterClick = function(event) {
	//
	const matchesSelector = '.' + this.filterClass;
	if(
		!event.target.matches(matchesSelector) &&
		!event.target.matches(matchesSelector + ' *')
	) {
		return;
	}

	event.preventDefault();

	// Update the page
	const filterEl = event.target.closest(matchesSelector);
	const selectedType = String(filterEl.dataset.type);
	this.updateActiveFilter(selectedType);
};

/**
 * Update the select and filter links to show the active filter
 * @param     { string } selectedType    The post type that should be visible
 * @return    { void }
 */
SearchResultFilters.prototype.updateActiveFilter = function(selectedType) {
	// Activate the correct filter
	this.allFilterEls.forEach(function(filterEl) {
		const filterType = String(filterEl.dataset.type);
		const isActive = filterType === selectedType;
		filterEl.classList.toggle(this.activeFilterClass, isActive);
	}, this);

	// Update the select
	this.selectEl.value = selectedType;

	// Show/Hide results
	this.showHideCards(selectedType);
};

/**
 * Toggle result card visibility
 * @param     { string } activePostType    The post type that should be visible
 * @return    { void }
 */
SearchResultFilters.prototype.showHideCards = function(activePostType) {
	this.allResultEls.forEach(function(resultEl) {
		const resultPostType = String(resultEl.dataset.type);

		const resultHidden = (
			'' !== activePostType &&
			resultPostType !== activePostType
		);

		resultEl.classList.toggle(this.resultHiddenClass, resultHidden);
	}, this);
};

// Init a handler for each instance of the search form
const bodyEl = document.querySelector('body.search-results');
if (bodyEl instanceof window.HTMLElement) {
	new SearchResultFilters(bodyEl);
}
